import { render } from "./g-card-resumo.vue?vue&type=template&id=df966334&scoped=true"
import script from "./g-card-resumo.vue?vue&type=script&lang=js"
export * from "./g-card-resumo.vue?vue&type=script&lang=js"

import "./g-card-resumo.vue?vue&type=style&index=0&id=df966334&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df966334"]])

export default __exports__